module.exports = __webpack_public_path__ + "img/feature_a04.d5d7c4f2.svg";